<div class="locker-location-page">
  <div class="container locker-location-shell">
    <section class="locker-location-panel">
      <div class="locker-location-header">
        <span class="locker-location-step">1.</span>
        <div>
          <h2>{{'reserve.location.title'|traduccion}}</h2>
          <p>Selecciona el locker en el mapa y continúa con tu reserva.</p>
        </div>
      </div>

      <div class="locker-location-content" *ngIf="locations.length; else noLocations">
        <div class="locker-map-card">
          <div class="locker-map-frame">
            <iframe
              [src]="mapEmbedUrl | safe"
              title="Mapa de lockers"
              loading="lazy">
            </iframe>

            <div class="locker-map-overlay">
              <button
                *ngFor="let location of locations; trackBy: trackByLocation"
                type="button"
                class="locker-map-pin"
                [class.active]="selectedLocation?.id === location.id"
                [style.left.%]="location.markerX"
                [style.top.%]="location.markerY"
                [disabled]="!hasCoordinates(location)"
                (click)="selectLocation(location)">
                <span class="locker-map-pin__dot"></span>
                <span class="locker-map-pin__label">{{ location.name }}</span>
              </button>
            </div>
          </div>

          <div class="locker-map-footer" *ngIf="selectedLocation">
            <div>
              <strong>{{ selectedLocation.name }}</strong>
              <p>{{ selectedLocation.addressLine }}</p>
            </div>
            <button
              type="button"
              class="btn btn-warning locker-cta-mobile"
              [disabled]="isReserving"
              (click)="reserveLocation(selectedLocation)">
              Reservar aqui
            </button>
          </div>
        </div>

        <div class="locker-location-list">
          <button
            *ngFor="let location of locations; trackBy: trackByLocation"
            type="button"
            class="locker-location-item"
            [class.active]="selectedLocation?.id === location.id"
            (click)="selectLocation(location)">
            <div class="locker-location-item__marker"></div>
            <div class="locker-location-item__body">
              <h3>{{ location.name }}</h3>
              <p>{{ location.addressLine }}</p>
              <p *ngIf="location.cityLine">{{ location.cityLine }}</p>
            </div>
          </button>

          <button
            *ngIf="selectedLocation"
            type="button"
            class="btn btn-warning locker-cta-desktop"
            [disabled]="isReserving"
            (click)="reserveLocation(selectedLocation)">
            Reservar en {{ selectedLocation.name }}
          </button>
        </div>
      </div>
    </section>
  </div>
</div>

<ng-template #noLocations>
  <div class="locker-location-empty">
    <p>No hay ubicaciones disponibles en este momento.</p>
  </div>
</ng-template>
